'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemAnnotationInput = require('./components/ItemAnnotationInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemAnnotationInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/web-results/components/item-annotation-input/index.js
// module id = 510
// module chunks = 1